import { render, staticRenderFns } from "./NavigationSubmenuItem.vue?vue&type=template&id=46370f6d&"
import script from "./NavigationSubmenuItem.vue?vue&type=script&lang=js&"
export * from "./NavigationSubmenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports